import React from "react";
import { Skeleton } from "@heroui/skeleton";

const ResearchReportSkeleton = () => {
  return (
    <section id="news-skeleton" className="mt-5 bg-white border rounded-xl p-4">
      {/* List skeleton with responsive design */}
      <ul className="space-y-4">
        {[...Array(2)].map((_, index) => (
          <li
            key={index}
            className="flex flex-col-row md:flex-row sm:flex-row justify-center items-center bg-white p-4 border-b"
          >
            {/* Main text placeholders */}
            <div className="flex-1">
              <Skeleton className="h-6 w-3/4 mb-2 rounded-lg" />
              <Skeleton className="h-4 w-full mb-1 rounded-lg" />
              <Skeleton className="h-4 w-5/6 mb-1 rounded-lg" />
              <Skeleton className="h-4 w-5/6 mb-1 rounded-lg" />
              <Skeleton className="h-4 w-1/4 mb-2 rounded-lg" />
            </div>

            {/* Image placeholders with responsive utility classes */}
            <div className="image-container md:w-1/3 sm:w-1/3 w-1/3 md:pl-5 sm:pl-5 pt-5 md:pt-0 mb-4 sm:pt-0">
              <Skeleton className="w-full h-20  md:h-24 lg:h-24 sm:h-60 rounded-lg" />
            </div>
          </li>
        ))}
      </ul>

      {/* Pagination skeleton */}
      <div className="flex justify-center mt-5">
        <Skeleton className="h-10 w-48 rounded-lg" />
      </div>
    </section>
  );
};

export default ResearchReportSkeleton;
